module.exports = __webpack_public_path__ + "img/filter-line.fa31d4f6.svg";